import {useEffect, useReducer, useState} from 'react'

import '../../assets/css/estoqueLoja.css'
import '../../assets/css/fonts.css'
import '../../assets/css/loaderEspiral.css'
import { ConsultaColecoesRevistas, ConsultaEstoqueLoja } from '../funcionalidades/bancoGet.js'
import preencheInfo from '../funcionalidades/reducerEstoqueLoja.jsx'
import MenuSuperior from '../menuSuperior/MenuSuperior.js'
import GlobalVar from '../funcionalidades/GlobalVar.jsx'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from 'sweetalert2'

const ItemEstoque = ({item})=>{
    console.log(Object.keys(item))
    const codigosExcluir = [ 'loja', 'pagina', 'nomfant', 'nome_fornecedor', 'codigo', 'rev_cod', 'item', 'desc_basica', 'descricao_rev', 'preco_basico', 
        'codpro', 'num_produto', 'tamanho', 'referencia', 'data','hora', 'cor']

        const urlImage = `https://apifornecedores.babita.com.br/images/${item.codpro}.jpg`


        const [bg, setBg] = useState('#FFF');
        
          useEffect(() => {
            console.log("TESTE IMAGE")
            console.log(urlImage)
            const img = new Image();
            img.src = urlImage;
        
            img.onload = () => {
              setBg(`url('${urlImage}')`);
            };
        
            img.onerror = () => {
              setBg(`url('https://apifornecedores.babita.com.br/images/publicImages/ImagemNaoEncontrada.jpg')`);
            };
          }, [urlImage]);

    return <div className="itemEstoque">
        <div className="fotoProd" style={{background: `${bg} no-repeat center/contain`}}></div>
        <div className='itemDesc'>
            <div className='revNome'>{item.nome_fornecedor}</div>
            <div>{item.codigo} - {item.nomfant}</div>
            <div>{item.item} - {item.desc_basica}</div>
            <div className="itemTmPg">
                <div>TAM.: {item.tamanho}</div>
                <div>PAG.: {item.pagina}</div>
            </div>
            <div>COR.: {item.cor}</div>
        </div>
        <div className="itemQuantd">
            {Object.keys(item).map((chave, index)=>{
                if (!codigosExcluir.includes(chave)) {
                return <div key={index}>{`${chave} : ${item[chave] ? item[chave] : 0}`}</div>;
            }})}
            </div>
    </div>
}

export default function EstoqueLoja({ativaResp}){

        const [stateInfo, dispachInfo] = useReducer(preencheInfo, {for_cod : '', item_cod: '', dadosBd : null, showFiltroEstoque: false,
        pagina: '', alerta: {status: false, title: '', text: ''}, ultimaAtt: '', fornList: [], carregando: false, limpar: false,
        atualizaEstoque: false, num_prod:'', referencia: '', codRevista: 0, resvistaList: []})
        const usuario = GlobalVar.getLocalStorage('usuario')


        const [visibleItems, setVisibleItems] = useState(20); // LIMITADOR DE PRODUTOS PARA PERFORMACE
        const [loading, setLoading] = useState(false);
        const lojaLogada = localStorage.getItem('loja')


        const handleScroll = async () => {
            const dadosEstoque = await GlobalVar.getLocalStorage('estoqueLoja')
            if(!dadosEstoque) return;
            const bottom = await Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight-300;
            if (bottom && !loading && visibleItems < dadosEstoque.length) {
                await setLoading(true);
                await setVisibleItems(prev => prev + 10); // Carrega mais 10 itens
                await setLoading(false);
            }
          };


          const geraRelatorio = async ()=>{
                const dadosEstoque = await stateInfo.dadosBd ? stateInfo.dadosBd : GlobalVar.getLocalStorage('estoqueLoja')
                const ws = await XLSX.utils.json_to_sheet(dadosEstoque);
                const wb = await XLSX.utils.book_new();
                await XLSX.utils.book_append_sheet(wb, ws, "Dados");
            
                // Criar o arquivo e fazer download automático
                const excelBuffer = await XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const blob = await new Blob([excelBuffer], { type: "application/octet-stream" });
                await saveAs(blob, "dados.xlsx");
            
          }
        
          useEffect(() => {
            window.addEventListener('scroll', handleScroll);
            return () => {
              window.removeEventListener('scroll', handleScroll);
            };
          }, []); // Adiciona e remove o listener de scroll no montar e desmontar do componente

        //   useEffect(()=>{
        //         console.log(stateInfo.atualizaEstoque)
        //         ConsultaHoraAtualizacaoEstoque()
        //         .then( resp =>{
        //             if(resp.Error){
        //                 dispachInfo({type:'ultimaAtt', value: null})
        //                 GlobalVar.setLocalStorage('ultimaAtt', null)
        //                 dispachInfo({type:'atualizaEstoque', value: false})
        //             }else{
        //                 dispachInfo({type:'ultimaAtt', value: resp[0]})
        //                 GlobalVar.setLocalStorage('ultimaAtt', resp[0])
        //                 dispachInfo({type:'atualizaEstoque', value: false})
        //             }
        //         })
        //         .catch(()=>{Swal.fire({title: 'Algo deu errado', text:"Sistema Indisponível!", icon: "error"})})
        //   },[stateInfo.atualizaEstoque])
                            

        //Busca os totais filtrando por codigos ou não
        useEffect(()=>{
            ConsultaColecoesRevistas({})
                .then(resp => {
                    if(resp.Error){
                        dispachInfo({type:'alerta', value: {status: true, title: "Algo deu errado", text: resp.Error}})
                    }else{
                        const resvistaList = resp.map((val)=>{
                            return {key: val.rev_num_rev, value: val.rev_nom}
                        })
                        dispachInfo({type:'resvistaList', value: resvistaList})
                    }
                }) 
        }, [])


        useEffect(()=>{
            console.log("ATUALIZA ESTOQUE LOG 2")
            dispachInfo({type:'dadosBd', value: GlobalVar.getLocalStorage('estoqueLoja')})
                dispachInfo({type:'ultimaAtt', value: GlobalVar.getLocalStorage('ultimaAtt')})
                if(stateInfo.atualizaEstoque === true){
                    dispachInfo({type:'carregando', value: true})
                    ConsultaEstoqueLoja({CODEMP: lojaLogada, AD_CODREV: 0, AD_CODFORNE: 0, AD_CODITEM: 0, AD_PAGINA: 0})
                        .then(resp => {
                            if(resp.Error){
                                console.log("ERROR")
                                dispachInfo({type:'carregando', value: false})
                                dispachInfo({type:'alerta', value: {status: true, title: "Algo deu errado", text: resp.Error}})
                                dispachInfo({type:'atualizaEstoque', value: false})
                            }else{
                                console.log("RESP 2")
                                console.log(resp)
                                const ultimaAtt = resp.pop()
                                console.log("POP")
                                console.log(ultimaAtt)
                                GlobalVar.setLocalStorage('estoqueLoja', resp)
                                GlobalVar.setLocalStorage('ultimaAtt', resp[0].data.split("T")[0] + " - " + resp[0].hora)
                                
                                dispachInfo({type:'dadosBd', value: resp})
                                dispachInfo({type:'ultimaAtt', value: resp[0].data.split("T")[0] + " - " + resp[0].hora})

                                dispachInfo({type:'atualizaEstoque', value: false})
                            }
                        })            
                }
        },[stateInfo.atualizaEstoque])


        useEffect(()=>{ //ATUALIZA AO ENTRAR NA TELA
            console.log("ATUALIZA ESTOQUE")
            ConsultaEstoqueLoja({CODEMP: lojaLogada, AD_CODREV: 0, AD_CODFORNE: 0, AD_CODITEM: 0, AD_PAGINA: 0})
                .then(resp => {
                    if(resp.Error){
                        //IGNORA ERRO
                        console.log("ERROR")
                    }else{
                        console.log(resp)
                        const ultimaAtt = resp.pop()
                        
                        GlobalVar.setLocalStorage('estoqueLoja', resp)
                        GlobalVar.setLocalStorage('ultimaAtt', resp[0].data.split("T")[0] + " - " + resp[0].hora)
                        
                        dispachInfo({type:'dadosBd', value: resp})
                        dispachInfo({type:'ultimaAtt', value: resp[0].data.split("T")[0] + " - " + resp[0].hora})

                        dispachInfo({type:'atualizaEstoque', value: false})
                    }
                })   
},[])
        
        useEffect(()=>{ //FILTRO DE PRODUTOS
            if(stateInfo.showFiltroEstoque === false && stateInfo.dadosBd){
                //stateInfo.for_cod.key
                const dadosEstoque = GlobalVar.getLocalStorage('estoqueLoja')
                const dadosFiltrados = dadosEstoque.filter((val,index)=>{
                    
                    const vazio = {
                        for_cod : stateInfo.for_cod === 0 || stateInfo.for_cod === '',
                        item_cod : stateInfo.item_cod === 0 || stateInfo.item_cod === '',
                        codRevista: stateInfo.codRevista.key === 0 || stateInfo.codRevista.key === '',
                        pagina: stateInfo.pagina === 0 || stateInfo.pagina === '',
                    }
                    let filtraEstoque = true
                    filtraEstoque = filtraEstoque && (val.codigo ? val.codigo === stateInfo.for_cod || vazio.for_cod : vazio.for_cod)
                    filtraEstoque = filtraEstoque && (val.item ? val.item === stateInfo.item_cod || vazio.item_cod : vazio.item_cod)

                    filtraEstoque = filtraEstoque && (stateInfo.codRevista.key ? 
                    (val.rev_cod ? val.rev_cod === stateInfo.codRevista.key || vazio.codRevista : vazio.codRevista) : true ) 
                    filtraEstoque = filtraEstoque && (val.pagina ? val.pagina === stateInfo.pagina || vazio.pagina : vazio.pagina)
                    return filtraEstoque
                })

                if(dadosFiltrados.length === 0){
                    dispachInfo({type:'alerta', value: {status: true, title: "Algo deu errado", text: "Item não encontrado ou com estoque 0 para o filtro usado."}})
                }else{
                    dispachInfo({type:"dadosBd", value: dadosFiltrados})
                }
            }
            
        },[stateInfo.showFiltroEstoque])

        useEffect(()=>{ //LIMPA CAMPOS FILTRO
            if(stateInfo.limpar){
                dispachInfo({type:'for_cod', value: ''})
                dispachInfo({type:'item_cod', value: ''})
                dispachInfo({type:'codRevista', value: 0})
                dispachInfo({type:'pagina', value: ''})
                dispachInfo({type:'limpar', value: false})
            }
        },[stateInfo.limpar])

        useEffect(()=>{
            if(stateInfo.alerta.status){
                Swal.fire({
                    title: stateInfo.alerta.title,
                    text: stateInfo.alerta.text,
                    icon: "error",
                    confirmButtonText: "OK"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        dispachInfo({ type: "alerta", value: { status: false, title: "", text: "" } });
                    }
                    })
            }
        },[stateInfo.alerta])

        // if(!usuario) return;

        return <>
        <MenuSuperior />
         <div className='estoqueLoja scrollbar' style={{minHeight: "100vh", /*maxHeight: windowHeight, */display: 'flex',
        flexDirection: 'column', overflowY: "hidden"}}>
          


                { !stateInfo.showFiltroEstoque ? <div className="btnShowFiltroEstoque" 
                                onClick={()=>{dispachInfo({type:'showFiltroEstoque', value: true})}}>Filtrar</div> : <></>}

                    { stateInfo.showFiltroEstoque ? <div className="filtroEstoqueLogisitca">

                    {stateInfo.resvistaList ? 
                            <select className="selectCustomizado" value={JSON.stringify(stateInfo.codRevista)} 
                            onChange={(event)=>{
                                dispachInfo({type:'codRevista', value: JSON.parse(event.target.value)})}}>

                                <option value={JSON.stringify({key: 0})}>Seleciona uma Revista</option>

                                {stateInfo.resvistaList.map((opcao, i) => (
                                    <option key={opcao.key} value={JSON.stringify(opcao)}>
                                    {opcao.value}
                                    </option>
                                ))}
                                </select> : <></>
                                }
                            <div>
                                <div>Cod. Forn.</div>
                                <input type="text"  className="inputEstoqueItem" placeholder='Cod. Fornecedor'
                                    onChange={(event)=>dispachInfo({type:'for_cod', value: event.target.value})} value={stateInfo.for_cod}/>
                            </div>

                            <div>
                                <div>Cod. item.</div>
                                <input type="text"  className="inputEstoqueCodForn" placeholder='Cod. Item'
                                    onChange={(event)=>dispachInfo({type:'item_cod', value: event.target.value})} value={stateInfo.item_cod}/>
                            </div>

                            <div>
                                <div>Pagina</div>
                                <input type="text"  className="inputEstoqueCodForn" placeholder='Pagina'
                                    onChange={(event)=>dispachInfo({type:'pagina', value: event.target.value})} value={stateInfo.pagina}/>
                            </div>

                            <div className="btnShowFiltroEstoque" 
                                onClick={()=>{dispachInfo({type:'showFiltroEstoque', value: false})}}>Filtrar</div>
                            <div className="btnShowFiltroEstoque" 
                                onClick={()=>{dispachInfo({type:'limpar', value: true})}}>Limpar</div>
                        </div> : <></>}
            
            
        <div className="btnShowAtualizaEstoque" 
                onClick={()=>{dispachInfo({type:'atualizaEstoque', value: true})}}>Atualizar Estoque</div>

        <div className="btnShowAtualizaEstoque" 
                onClick={()=>{geraRelatorio()}}>Gerar Relatório Excel</div>

        {stateInfo.ultimaAtt ? <div className="ultimaAtt" >Última Att.: {stateInfo.ultimaAtt}</div> : <></>}
        {stateInfo.dadosBd ? <> 
        <div className="listaEstoqueItens" style={!stateInfo.dadosBd ? {gridTemplateColumns: "100%"} : {}}>
                {Array.isArray(stateInfo.dadosBd) ? stateInfo.dadosBd.slice(0, visibleItems).map((val, index)=> <ItemEstoque item={val} key={"itemEstoque"+index}/>) : <></>}
            </div>

            </>
            : stateInfo.carregando ? <div className="loaderContainer"><span className="loader"></span><div className="loadText">
                {'Aguarde enquanto buscamos o estoque'}
                </div> </div> : <></>}
            
         </div>
         </> 
}